import awardDialog from '@src/components/awardDialog'
import rankList from '../components/rankList'
import inviteList from '../components/inviteList'
import { getInviteActivityInfoByActId, getDetailRank, getShareScoreRecord, getUserApply } from './services'
import HeadNav from '@src/components/head_nav'
import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'
import dayjs from 'dayjs'
import BubbleMsg from "@src/components/bubbleMsg";
import inviteCard from '../components/inviteCard.vue'
import defaultPage from '../components/defaultPage.vue'
import util, { ridUrlParam, addUrlParameter } from "@src/utils/util.js"
import Lottie from "@src/components/lottie"

const refreshActivity = 'oap://qg/home/refresh/activitymask'
let vm = {
  components: {
    HeadNav,
    awardDialog,
    rankList,
    inviteList,
    inviteCard,
    BubbleMsg,
    defaultPage,
    Lottie
  },
  data() {
    return {
      isShowRuleDialog: false,
      lineWidth: '',
      activeTabIndex: 0,
      isScroll: false,
      isNight: false,
      isDetail: true,
      userRewardRsp: {},
      loading: false,
      rankListLoading: false,
      inviteScorePageEnd: false,
      rankScorePageEnd: false,
      isShowAwardDialog: false,
      isChangeListHeight: false,
      isShowTip: false,
      showEnterCode: false,
      inviteList: [],
      style: '',
      isBlack: true,
      backgroundStyle: {
        backgroundColor: '',
      },
      fontStyle: {
        color: ''
      },
      isShowDefaultPage: false,
      defaultPageOptions: {},
      rewardType: 0,
      rule: '',
      inviteCode: '',
      inviteTipDesc: '',
      symbol: '',
      actPic: '',
      outPic: '',
      rulePic: '',
      sharePic: '',
      iconPicUrl: '',
      supportRegion: '',
      score: '',
      rewardInvitedNum: 0,
      rewardInviterNum: 0,
      ranks: [],
      bubbleMsg: [],
      pageSize: 10,
      userInfo: {},
      shareScoreListLoading: false,
      shareScorePage: 0,
      rankPosition: 0,
      totalScore: 0,
      totalTimes: 0,
      isShowedDialog: false,
      fromPath: '',
      activityId: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPath = from.path
    })
  },
  async mounted() {
    window.addEventListener('load', function () {
      // this.firstScreenTime = Date.now() - timerStart > 1000 ? Date.now() - timerStart : 0
      console.log(Date.now() - timerStart)
    });
    this.isNight = util.isNight()
    let loading = document.getElementById('index-loading');
    loading.style.display = 'block';
    if (window.loading && window.loading.isPaused) {
      window.loading.play()
    }
    window.JsBridge = JsBridge
    window.loginCallback = function (data) {
      if (!data.success) {
        JsBridge.closePage()
      } else {
        if (JsBridge.getEnv() === 'gameHall') {
          JsBridge.openActivity(refreshActivity)
        }
      }
    }
    if (JsBridge.getEnv() === "gameHall") {
      if (JsBridge.isLogin()) {
        this.userInfo = window.android && JSON.parse(window.android.getUserInfo())
      }
      if (!JsBridge.isLogin()) {
        JsBridge.doLogin()
      }
    }
    this.setStatusBarFontColor(true)
    if (!this.checkVersionOver()) {
      this.isShowDefaultPage = true
      this.setLowVersionOptions()
      this.setStatusBarFontColor(false)
      this.endLoading()
      return
    }
    if (!this.checkLocalOver()) {
      this.isShowDefaultPage = true
      this.setStatusBarFontColor(false)
      this.endLoading()
      return
    }
    this.activityId = this.$route.query.activityId

    await this.getInviteActivityInfoByActId()
    let that = this
    window.onShow = function () {
      that.getInviteActivityInfoByActId()
    }
    this.getDetailRank()
    this.getShareScoreRecord()
    this.getUserApply()
    this.endLoading()
    window.addEventListener("scroll", e => {
      let scrollTop = document.documentElement.scrollTop
      this.style = `background: ${util.getColor(this.backgroundStyle.backgroundColor, scrollTop / 140)}; box-shadow: 0rem 0.33px 0rem rgba(0, 0, 0, 0.12)`
      if (scrollTop == 0) {
        this.style = `background: ${util.getColor(this.backgroundStyle.backgroundColor, scrollTop / 140)}`
      }
    })
    let { score } = this.$route.query
    this.score = parseInt(score) / 100
    if (!this.isShowDefaultPage && !this.isShowloginLoadingPage) {
      this.$nextTick(() => {
        //对从inviteCodePage页面进入到home页面不在展示获奖弹窗
        if (this.fromPath == "/inviteCodePage" || this.fromPath == "/rulePage") {
          this.isShowAwardDialog = false
          this.endLoading()
        }
        else if (!this.isShowedDialog && this.score) {
          this.isShowAwardDialog = true
        }
        if (window.performance.navigation.type == 1) {
          //home页面二次刷新时，不展示获奖弹窗
          this.isShowAwardDialog = false
        }
        //对初始化tab进行加载
        let elf = document.getElementsByClassName('van-tab')[0].childNodes[0]
        let els = document.getElementsByClassName('van-tab')[1].childNodes[0]
        let vanTabFirst = document.getElementsByClassName('van-tab')[0]
        this.lineWidth = window.getComputedStyle(elf).width
        this.lineWidths = window.getComputedStyle(els).width
        let padding = (328 - parseInt(this.lineWidth) - parseInt(this.lineWidths)) / 3
        vanTabFirst.style.paddingLeft = `${padding}px`
        vanTabFirst.style.paddingRight = `${padding}px`
        if (elf) {
          this.$refs.vantabs.resize();
        }
      })
    }
    window.shareCallback = function (data) {
      if (data.shareStatus === 'success') {
        ActStat.reportCustom(`finishShare_${data.channelId}`)
      }
    }
    ActStat.reportCustom('indexPv')
  },
  methods: {
    startLoading() {
      let loading = document.getElementById('index-loading')
      if (loading) {
        window.loading && window.loading.play()
        loading.style.display = 'block'
      }
    },
    setStatusBarFontColor(isWhiteFont) {
      if (JsBridge.getEnv() === 'gameHall') {
        window.android.setStatusBarFontColor(isWhiteFont)
      }
    },
    endLoading() {
      let loading = document.getElementById('index-loading')
      if (loading) {
        window.loading && window.loading.stop()
        loading.style.display = 'none'
      }
    },
    checkVersionOver() {
      if (JsBridge.getEnv() === 'gameHall' && JsBridge.getAppVersion() < 20400) {
        return false
      } else {
        return true
      }
    },
    checkLocalOver() {
      if (JsBridge.getEnv() === 'gameHall') {
        let userRegion = window.android.getUserRegion()
        this.urlRegion = util.getQueryString('region')
        if (this.urlRegion && this.urlRegion.toUpperCase() != userRegion.toUpperCase()) {
          this.setWrongLocalOption()
          return false
        } else {
          return true
        }
      }
      return true
    },
    setOfflineOptions() {
      let that = this
      this.defaultPageOptions = {
        content: this.$t('inviteDetail.gamesOffline'),
        btnText: this.$t('inviteDetail.seeMoreGames'),
        btnEvent: function () {
          if (JsBridge.getEnv() === 'gameHall') {
            JsBridge.openActivity('oap://qg/home')
          } else {
            let query = that.$route.query
            that.$router.push({ name: 'sharePage', query: { ...query, status: that.status } })
          }
        },
      }
    },
    setWrongLocalOption() {
      this.defaultPageOptions = {
        content: this.$t('inviteDetail.currentCountryNotSupport'),
        isUpgrade: false,
        btnText: this.$t('inviteDetail.seeMoreGames'),
        btnEvent: function () {
          JsBridge.openActivity('oap://qg/home')
        }
      }
    },
    setLowVersionOptions() {
      let that = this
      this.defaultPageOptions = {
        content: this.$t('inviteDetail.lowAppVersionNotSupport'),
        isUpgrade: true,
        btnText: this.$t('inviteDetail.upgrade'),
        btnEvent: function () {
          that.updateApp()
        },
      }
    },
    setnotInternetOption() {
      let that = this
      this.defaultPageOptions = {
        content: this.$t('inviteDetail.networkErr'),
        isUpgrade: true,
        btnText: this.$t('inviteDetail.refresh'),
        isInternet: true,
        async btnEvent() {
          that.isShowDefaultPage = false
          that.startLoading()
          await that.getInviteActivityInfoByActId()
          that.getUserApply()
          that.endLoading()
        },
      }
    },
    onTabChange(index) {
      this.setLineWidth(index)
      this.setListHeightChange(index)
    },
    setListHeightChange(index) {
      if (index === 1) {
        this.isChangeListHeight = true
      }
    },
    setLineWidth(index) {
      let el = document.getElementsByClassName('van-tab')[index].childNodes[0]
      this.lineWidth = window.getComputedStyle(el).width
    },
    enterCode() {
      let { activityId } = this.$route.query
      ActStat.reportCustom('inviteClickInviteCodebutton')
      this.$router.push({ name: 'inviteCodePage', query: { activityId, rewardType: this.rewardType, inviteTipDesc: this.inviteTipDesc, rewardInvitedNum: this.rewardInvitedNum, symbol: this.symbol } })
    },
    toWithdraw() {
      ActStat.reportCustom('inviteClicktoWithdrawbutton')
      JsBridge.openActivity('oap://qg/mine/mywallet')
    },
    hiddenDialog() {
      this.isShowDialog = false
    },
    laterShare() {
      this.isShowAwardDialog = false
    },
    ruleEvent() {
      ActStat.reportCustom('inviteClickRuleButton')
      this.$router.push({ name: 'rulePage', params: { rule: this.rule } })
    },
    updateApp() {
      let deepLink = `oap://qg/intent/view?url=${encodeURIComponent(
        'https://play.google.com/store/apps/details?id=com.heytap.quickgame'
      )}`
      JsBridge.openActivity(deepLink)
    },
    setShareObj() {
      ActStat.reportCustom('inviteClickShareButton')
      let url = location.href.replace(/home/g, 'sharePage')
      var queryConfig = {
        "inviteCode": this.inviteCode,
        "inviteName": this.userInfo.nickname.replace(/\s+/g, "-"),
        "rewardType": this.rewardType,
        "rewardInvitedNum": this.rewardInvitedNum,
        "symbol": this.symbol,
        "outPic": this.outPic
      };
      url = addUrlParameter(queryConfig, url)
      const statsArr = ['enter_id', 'pre_mod_id', 'pre_page_id']
      this.shartObj = {
        share_business_channel: "facebook,whatsapp,messenger,telegram,other",
        share_activity_id: 11,
        share_preview_type: 3,
        share_preview_info: JSON.stringify({
          bg: encodeURIComponent(this.sharePic),
          pureImg: 1,
        }),
        share_method_type: 1,
        share_method_info: JSON.stringify({
          shareLink: encodeURIComponent(`${ridUrlParam(url, statsArr)}`),
        }),
      }
    },
    toShare() {
      this.setShareObj()
      JsBridge.openActivity(`oap://qg/share?${objToQueryStr(this.shartObj)}`)
      ActStat.reportCustom('startShare')
    },
    async loadMoreRankListData() {
      // console.log(1231231)
    },
    async getInviteActivityInfoByActId() {
      let { activityId } = this.$route.query
      if (!activityId) {
        return
      }
      let res = await getInviteActivityInfoByActId({ activityId })
      if (res && res.code === 'failed' && res.message === 'Network Error') {
        this.isShowDefaultPage = true
        this.setnotInternetOption()
        this.setStatusBarFontColor(false)
        return
      }
      if (res.code === '5604') {
        this.setOfflineOptions()
        this.setStatusBarFontColor(false)
        this.isShowDefaultPage = true
        if (JsBridge.getEnv() === 'gameHall') {
          JsBridge.openActivity(refreshActivity)
        }
      }
      if (res.code === '2000') {
        let data = res.data
        this.rule = data.actRule
        this.inviteCode = data.inviteCode
        this.showEnterCode = data.showEnterCode
        this.inviteTipDesc = data.inviteTipDesc
        this.rewardType = data.rewardType
        this.supportRegion = data.supportRegion
        this.iconPicUrl = data.iconPicUrl
        this.actPic = data.actPic
        this.outPic = data.outPic
        this.rulePic = data.rulePic
        this.sharePic = data.sharePic
        this.symbol = data.symbol
        this.backgroundStyle.backgroundColor = data.backgroundColor
        this.fontStyle.color = data.backgroundColor
        this.rewardInvitedNum = data.rewardInvitedNum / 100
        this.rewardInviterNum = data.rewardInviterNum / 100
      }
    },
    async getDetailRank() {
      let { activityId } = this.$route.query
      if (!activityId) {
        return
      }
      let data = await getDetailRank({ activityId, pageNo: 0, pageSize: 10 })
      console.log(data)
      if (data) {
        this.ranks = data
        this.ranks.map((rank) => {
          let bubbleData = this.$t('inviteDetail.justGotCash', [rank.name, this.symbol + rank.score / 100])
          this.bubbleMsg.push(bubbleData)
        })
      }
    },
    async getUserApply() {
      let { activityId } = this.$route.query
      if (!activityId) {
        return
      }
      let data = await getUserApply(activityId, { isRank: true, isAward: false })
      console.log(data)
      this.rankPosition = typeof data.rankPosition === 'number' ? data.rankPosition : 0
      this.totalScore = data.totalScore / 100
      this.totalTimes = data.totalTimes
    },
    async getShareScoreRecord() {
      if (this.shareScoreListLoading) {
        return
      }
      this.shareScoreListLoading = true
      let { activityId } = this.$route.query
      let res = await getShareScoreRecord({ activityId, type: 3, pageNo: this.shareScorePage, pageSize: 6 })
      if (res.code === '2000') {
        let { results, end } = res.data
        this.shareScorePage++
        if (results.length < 5) {
          this.inviteScorePageEnd = true
        }
        this.inviteList = this.inviteList.concat(results)
        this.shareScoreListLoading = false
      } else {
        this.inviteScorePageEnd = true
      }
    },
    async loadMoreShareScoreRecord() {
      await this.getShareScoreRecord()
    },
  }
};

let objToQueryStr = obj => {
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    let strArr = []
    let keysArr = Object.keys(obj)
    for (let key of keysArr) {
      strArr.push(`${key}=${obj[key]}`)
    }
    return strArr.join('&')
  } else {
    return JSON.stringify(obj)
  }
}

export default vm;



// WEBPACK FOOTER //
// ./src/pages/index/scripts/index.js